import { useNavigate } from "react-router-dom";
import { CalendarDays, CheckCircle2 } from "lucide-react";
import { IDS } from "@/constants/testIds";

const daysLabel = (d) => {
  if (d === 0) return "today";
  if (d === 1) return "tomorrow";
  if (d > 1 && d < 7) return `in ${d} days`;
  if (d >= 7 && d < 14) return `in 1 week`;
  if (d >= 14 && d < 30) return `in ${Math.round(d / 7)} weeks`;
  if (d >= 30) return `in ${Math.round(d / 30)} month${d >= 60 ? "s" : ""}`;
  if (d === -1) return "yesterday";
  return `${Math.abs(d)}d ago`;
};

export default function EventCard({ event, compact = false }) {
  const navigate = useNavigate();
  const locked = !!event.chosen_option_id;
  const days = event.days_until;
  return (
    <button
      data-testid={IDS.eventCard(event.event_id)}
      onClick={() => navigate(`/events/${event.event_id}`)}
      className={`w-full text-left bg-white rounded-2xl border border-stone-100 shadow-[0_2px_8px_rgba(28,25,23,0.04)] active:scale-[0.99] transition-transform ${
        compact ? "p-4" : "p-5"
      }`}
    >
      <div className="flex items-start gap-3">
        <div className={`h-10 w-10 rounded-full flex items-center justify-center shrink-0 ${locked ? "bg-[#6B7A54] text-white" : "bg-stone-100 text-stone-700"}`}>
          <CalendarDays size={18} strokeWidth={1.5} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-[Manrope] font-bold tracking-[0.2em] uppercase text-[#6B7A54] truncate">
            {event.occasion}
          </div>
          <h3 className={`font-[Cormorant_Garamond] italic text-stone-900 leading-tight truncate ${compact ? "text-lg" : "text-xl"}`}>
            {event.name}
          </h3>
          <div className="mt-1 text-xs font-[Manrope] text-stone-500 flex items-center gap-2">
            <span>{daysLabel(days)}</span>
            {event.with_whom && <span className="truncate">· with {event.with_whom}</span>}
          </div>
          {locked && (
            <div className="mt-2 inline-flex items-center gap-1 text-[10px] font-[Manrope] font-semibold tracking-wider uppercase text-[#6B7A54]">
              <CheckCircle2 size={12} strokeWidth={1.8} /> Outfit locked
            </div>
          )}
        </div>
      </div>
    </button>
  );
}
